<template>
  <div class="all-box">

    <businessHeader v-if="$route.path != '/person'" id="IDRootHeader" class="header-box"></businessHeader>

    <div class="content-box" :style="{height:cardAreaH}">
      <!-- <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view> -->
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>

    </div>
    <!-- </transition> -->

    <van-tabbar v-if="$route.path == '/index' ||
        $route.path == '/type' ||
       $route.path == '/shopCar' ||
        $route.path == '/person'" route active-color="#a9936b" inactive-color="#000">
      <van-tabbar-item replace to="/index" icon="home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/type" icon="apps-o">
        分类
      </van-tabbar-item>
      <van-tabbar-item replace to="/shopCar" icon="shopping-cart-o">
        购物车
      </van-tabbar-item>
      <van-tabbar-item replace to="/person" icon="user-o">
        个人
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import businessHeader from "./businessHeader";
export default {
  components: {
    businessHeader,
  },
  data() {
    return {
      active: 0,
      cardAreaH: "",
      RouterState: true,
      drawerShow: true,
      transitionName: "slide-left",
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path);

      if (
        this.$route.path == "/index" ||
        this.$route.path == "/type" ||
        this.$route.path == "/shopCar" ||
        this.$route.path == "/person"
      ) {
        this.drawerShow = true;
      } else {
        this.drawerShow = false;
      }
      const toIndex = to.meta.index;
      const fromIndex = from.meta.index;
      console.log(toIndex);
      console.log(fromIndex);
      if (toIndex < fromIndex) {
        this.transitionName = "slide-right";
      } else {
        this.transitionName = "slide-left";
      }

      // this.transitionName = toIndex < fromIndex ? "slide-right" : "slide-left";
    },
  },
  mounted() {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.cardAreaH = h - 60 + "px";
    console.log("---------------------sss");
  },

  methods: {
    // navToPage(path){
    //   console.log(path)
    // }
    onChange(index) {
      console.log(index);
      switch (index) {
        case 0:
          this.$router.push("/index");
          break;
        case 1:
          this.$router.push("/type");

          break;
        case 2:
          this.$router.push("/shopCar");

          break;
        case 3:
          this.$router.push("/person");

          break;

        default:
          break;
      }
    },
    reload() {
      this.RouterState = false;
      this.$nextTick(() => {
        this.RouterState = true;
      });
    },
  },
};
</script>

<style  scoped>
.all-box {
  height: 100%;
  /*控制底部滚动*/
  overflow: hidden;
}

.header-box {
  position: absolute;
  top: 0px;
  z-index: 100;
  /* //box-shadow: 0 1px 0 0 #7C7C7C; */
  border-bottom: solid 1px #f4f4f4;
}

.content-box {
  margin-top: 60px;
  z-index: 2;
  background: #fff;
  width: 100%;
  /*padding-bottom: 44px;*/
  box-sizing: border-box;
  /* overflow: hidden; */
}
/* /deep/ .van-tabbar-item__icon i {
  font-weight: 600;
} */
.van-tabbar-item--active {
  font-weight: 600;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: relative;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/entrance.vue